'use client';

import { serverRuntimeConfigDefaultValue } from '@/utils/app-config';
import { Environment } from '@rhg/constants';
import { logger } from '@rhg/libs/logger';
import { createContext, ReactNode, useContext, useEffect } from 'react';

interface AppConfigProviderProps {
    children: ReactNode | ReactNode[];
    value: ServerRuntimeConfig;
    isMocked?: boolean;
}

const AppConfigContext = createContext<ServerRuntimeConfig>(
    serverRuntimeConfigDefaultValue
);

export const AppConfigProvider = ({
    children,
    value,
    isMocked,
}: AppConfigProviderProps) => {
    useEffect(() => {
        if (
            !isMocked &&
            [Environment.STAGING, Environment.DEV, Environment.LOCAL].includes(
                value.NEXT_PUBLIC_ENV as Environment
            )
        ) {
            logger.debug('Received AppConfig', { ...value });
        }
    }, [isMocked, value]);

    return (
        <AppConfigContext.Provider value={value}>
            {children}
        </AppConfigContext.Provider>
    );
};

function useAppConfig() {
    return useContext(AppConfigContext);
}

export default useAppConfig;
